import React from 'react';
import Navbar from '../../components/navbar/navbar';
import Footer from '../../components/footer';
import OfficeSpaceCalculator from '../../components/office-space-calculator';

const OfficeSpaceCalculatorPage: React.FC = () => {
    return (
        <div className="bg-slate-50 min-h-screen">
            <Navbar transparent={false} />

            <div className="relative pt-6 md:pt-10 pb-6 md:pb-10 bg-white border-b border-slate-100 overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-full opacity-5">
                    <div className="absolute top-10 left-10 w-64 h-64 bg-[#001b4a] rounded-full blur-3xl"></div>
                    <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#f1ae24] rounded-full blur-3xl"></div>
                </div>

                <div className="container px-6 relative z-10 mx-auto">
                    <div className="max-w-4xl">
                        <nav className="flex items-center gap-2 text-slate-400 text-xs font-medium tracking-wide mb-1 md:mb-2">
                            <span>Tools</span>
                            <i className="fa-solid fa-chevron-right text-[8px]"></i>
                            <span className="text-[#001b4a]">Office Space Calculator</span>
                        </nav>
                        
                        <h1 className="text-3xl md:text-5xl font-bold text-[#001b4a] mb-2 md:mb-4 leading-tight">
                            Office Space <span className="text-[#f1ae24]">Calculator</span>
                        </h1>
                        <p className="text-slate-500 text-base font-medium max-w-2xl leading-relaxed">
                            Estimate workspace area, amenity needs and total sq.ft. for your office layout.
                        </p>
                    </div>
                </div>
            </div>

            <section className="py-6 md:py-8 -mt-10 relative z-20">
                <div className="container px-6 mx-auto">
                    <div className="max-w-6xl mx-auto">
                        <OfficeSpaceCalculator />
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default OfficeSpaceCalculatorPage;
